module.exports = __webpack_public_path__ + "img/end1.8e228e81.svg";